/** @format */

const getNotificationText = type => {
  switch (type) {
    case 'newRequest':
      return 'Una nuova richiesta è stata inoltrata al magazzino';
    case 'updateRequest':
      return 'Una richiesta precedentemente inoltrata è stata modificata';
    case 'requestChecked':
      return 'Il magazzino ha terminato i controlli su una richesta.';
    default:
      return '';
  }
};

export default getNotificationText;
